import { TPagination } from '@/_types';

export const URL_PATH = '/article/tips';

export const SEARCH_TIPS_PAGINATION: TPagination = {
  offset: 0,
  limit: 5,
};
